import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AttachmentsService } from '../services/attachments/attachments.service';
import {UserLoginView} from "@model";
import {getManualNameFromRoleId} from "@utils";
import {Observable} from "rxjs";
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly attachments:AttachmentsService,
  ) { }

  showUserHeader:boolean = true;
  userInfo!: UserLoginView;
  ngOnInit(): void {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}');

      this.router.events.subscribe((ev) => {
        if (ev instanceof NavigationEnd) {
          this.showUserHeader = (this.router.url !== '/');
        }
      });
  }

  getManual() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}')
    const isLoggedIn = !!this.userInfo && this.router.url !== '/' && !this.router.url.includes('landing');
    const downloadCallback: Observable<Blob> = isLoggedIn ? this.attachments.downloadRestrictedManual() : this.attachments.downloadExternalManual();
    const manualName = isLoggedIn ? this.populateManualName() : 'Cruscotto_QRSP.pdf';

    downloadCallback.subscribe({
      next: (response: Blob) => {
        const doc = new Blob([response]);
        this.downloadManual(doc, manualName);
      }
    })
  }


  populateManualName(): string {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}');
    return getManualNameFromRoleId(this.userInfo?.ruolo?.id ?? -1);
  }

  downloadManual(doc: Blob, fileName: string) {
    let element = document.createElement('a');
    element.href = window.URL.createObjectURL(doc);
    element.download = fileName;
    element.click();
    element.remove();
  }
}
